import React from 'react'
import {Link} from 'react-router-dom';
import Form from "../../../components/form/Form";
import DashboardPanel from "./DashboardPanel";
import Calendar, {WeekInputComponent} from './Calendar';
import Opportunity from "../../../models/Opportunity";
import DashboardPreferences from '../../talent-preferences/components/DashboardPreferences';


export default class AvailabilityPanel extends DashboardPanel {

    // static header = 'talent.dashboard.availability_title';
    static header = 'Availability and Work Status';

    static is_active = true;
    static inactiveMessage = 'Use our availability calendar to manage when you’re open for work.';

    static LastUpdatedMethod = 'lastUpdatedWorkStatus';
    static columns = 'auto'
    static colClass = ''

    static columnProps = {
        xl: 6,
        lg: 7,
        md: 7,
        sm: 12,
        xs: 12
    }
    static columnOrdering = {
        xl: 2,
        lg: 2,
        md: 2,
        sm: 3,
        xs: 3
    }

    constructor(props, context) {
        super(props, context);

        this.form = React.createRef();
        this.state = {
            auth: TB.pick(props.user || context?.auth || {}, ['work_schedule_weeks', 'available_hours_per_week', 'is_available', 'talent_commitment_level',
                                                              'has_contract_to_hire_interest',
                                                              'has_full_time_employment_interest']),
            isEditing: false,
            isLoading: false,
        }
    }


    isDisabled() {
        return false
        // return !this.hasCompletedProfile()
    }

    mapModel(model) {
        let auth = { ...this.state.auth };

        let params = {
            work_schedule_weeks: {
                ...auth.work_schedule_weeks
            },
            available_hours_per_week: model.available_hours_per_week
        }
        TB.map(model, (value, key) => {
            params = TB.set(params, key, value);
        });

        return params;
    }

    async onSubmit(model) {
        let params = this.mapModel(model);
        params.work_schedule_weeks = TB.map(params.work_schedule_weeks, (hours, week) => {
            return {
                started_at: week,
                available_hours: parseInt(hours) || 0
            }
        });
        let updated = await this.talentUpdate(params);
        if (updated) {
            return TB.sysAlert('talent.availability_updated_success')
        }
    }

    async toggleAvailability(checked) {
        let is_available = checked ? 1 : 0;

        if (!is_available) {
            let confirm = await TB.sysAlert('talent.turn_off_availability_warning');
            if (!confirm) return;
        }

        let updated = await this.talentUpdate({ is_available });

        if (!updated) {
            return;
        }

        if (is_available) {
            return await TB.sysAlert('talent.availability_turned_on');
        } else {
            Opportunity.clearCache();

            return await TB.sysAlert('talent.availability_turned_off');
        }
    }

    async talentUpdate(params) {
        if (this.state.isLoading) return false;

        await this.setState({ isLoading: true })

        let auth = await TB.auth().talentUpdate(params);

        if (auth) {

            await this.setState({
                auth: TB.pick(auth, [
                    'work_schedule_weeks',
                    'available_hours_per_week',
                    'is_available',
                    'talent_commitment_level',
                    // 'has_contract_to_hire_interest',
                    'has_full_time_employment_interest',
                ]),
            })
        }

        await TB.wait(250);

        await this.setState({ isLoading: false })

        return auth;
    }

    async syncAllWeeksToDefault() {
        let {
            available_hours_per_week,
            is_available,
            work_schedule_weeks
        } = this.state.auth;

        let auth = {
            available_hours_per_week,
            is_available,
            work_schedule_weeks: {}
        };

        for (let [week, hours] of Object.entries(work_schedule_weeks)) {
            auth.work_schedule_weeks[week] = available_hours_per_week
        }

        return this.setState({ auth })
    }

    resetAvailability() {
        return this.setState({
            isEditing: false,
            auth: TB.pick({ ...(this.context?.auth || {}) }, [
                'is_available',
                'work_schedule_weeks',
                'available_hours_per_week',
                'talent_commitment_level',
                'has_contract_to_hire_interest',
                'has_full_time_employment_interest',
            ])
        })
    }

    renderPanel() {

        if (this.isDisabled()) {
            return this.renderDisabled()
        }

        if (this.isInactive()) {
            return this.renderInactive()
        }

        return (
            <div className="talent-dashboard-panel justify-start">
                <Form
                    ref={this.form}
                    className="default-form availability-form"
                    submitButton={false}
                    background={'none'}
                    model={this.state.auth}
                    fields={[]}
                    onSubmit={this.onSubmit.bind(this)}
                    onChange={model => {

                        let auth = this.mapModel(model);

                        this.setState({ auth: { ...this.state.auth, ...auth } })
                    }}>

                    {this.renderPanelHeader()}

                    {this.renderAvailabilityToggle()}

                    {this.renderPanelContent()}

                    {this.renderPanelFooter()}

                </Form>
            </div>
        )
    }

    renderAvailabilityToggle() {
        let { readOnly, user } = this.props;
        let { auth, isLoading } = this.state;

        return (
            <>
                <DashboardPreferences
                    onChange={model => {
                        console.log('availabilitypanelchange', model)
                        return this.talentUpdate(model)
                    }}
                    isDisabled={isLoading || readOnly}
                />

                <div className="flex justify-end pb-2">
                    <Link
                        to="/talent/work-preferences"
                        className="btn btn-link"
                    >
                        Edit work preferences
                    </Link>
                    {/*<button*/}
                    {/*    type="button"*/}
                    {/*    className="btn btn-primary"*/}
                    {/*    disabled={isLoading || readOnly}*/}
                    {/*    onClick={() => {*/}
                    {/*        try {*/}
                    {/*            this.talentUpdate(*/}
                    {/*                TB.pick(auth, [*/}
                    {/*                    'is_available',*/}
                    {/*                    'talent_commitment_level',*/}
                    {/*                    'has_contract_to_hire_interest',*/}
                    {/*                ])*/}
                    {/*            )*/}
                    {/*            return TB.sysAlert('talent.availability_updated_success')*/}

                    {/*        } catch (error) {*/}
                    {/*            console.log(error, 'error')*/}
                    {/*        }*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    Save Preferences*/}
                    {/*</button >*/}
                </div>

                {/* <div className="form-group availability-toggle">
                    <label htmlFor="availability-toggle">
                        <span>
                            {
                                user ? `Active on the ${laravel.platform_name} Marketplace`
                                    : `I want to be active on the ${laravel.platform_name} Marketplace`
                            }
                        </span>

                        <Switch
                            height={21}
                            width={48}
                            style={{ transform: [{ scaleX: .7 }, { scaleY: .7 }] }}
                            checked={!!auth.is_available}
                            onChange={this.toggleAvailability.bind(this)}
                            onColor={TB.config('color.light_green')}
                            offColor={'#C2CFE0'}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            activeBoxShadow={'0 0 1px 2px ' + TB.config('color.light_purple')}
                            className="react-switch"
                            id="availability-toggle"
                            disabled={isLoading || readOnly}
                        />
                    </label>
                </div> */}
            </>

        )
    }

    renderPanelContent() {

        return (

            <div className="availability-calendar">
                <Calendar
                    isLoading={this.state.isLoading}
                    readOnly={this.props.readOnly}
                    isEditing={this.state.isEditing && !this.props.readOnly}
                    availableHoursPerWeek={this.state.auth.available_hours_per_week || ''}
                    workScheduleWeeks={this.state.auth.work_schedule_weeks || {}}
                />
            </div>
        )
    }

    renderPanelFooter() {
        let { readOnly } = this.props;
        let { isEditing, auth, isLoading } = this.state;
        return (
            <div className="availability-footer">
                <div className="edit-availability-default">

                    <div className="input-container">
                        <span>
                            Default available hours per week
                        </span>
                        <WeekInputComponent
                            name={'available_hours_per_week'}
                            value={auth.available_hours_per_week}
                            disabled={!isEditing || readOnly}
                        />
                    </div>


                    {isEditing && !readOnly && (
                        <button
                            type="button"
                            onClick={async () => {
                                let confirm = await TB.alert(
                                    'alert',
                                    'Reset All Weeks?',
                                    "Are you sure you want to set all weeks to your default available hours per week?",
                                    [
                                        {
                                            title: 'Yes, continue'
                                        },
                                        {
                                            title: 'Cancel'
                                        }
                                    ]
                                );
                                if (confirm) return this.syncAllWeeksToDefault();
                            }}
                            disabled={isLoading}
                            className="btn btn-link-primary">
                            Set all weeks to this default
                        </button>
                    )}

                </div>

                {!this.isDisabled() && !readOnly && !this.isInactive() && (
                    <div className="edit-availability-button">

                        <button type={isEditing ? 'button' : 'submit'}
                            className="btn btn-primary" disabled={isLoading}
                            onClick={() => this.setState({ isEditing: !isEditing })}>

                            {isEditing ? 'Save Changes' : 'Click to edit availability'}

                        </button>

                        {isEditing && (
                            <button type="button" className="btn btn-light ml-3"
                                disabled={isLoading} onClick={this.resetAvailability.bind(this)}>
                                Cancel
                            </button>
                        )}
                    </div>
                )}
            </div>
        )
    }
}